import axios from "axios";
import { API_BASE_URL } from "../config";
import { getToken, clearSession } from "./session";

// Single axios instance for all API calls. baseURL points at the /api root,
// so callers use paths like "/products", "/categories/add", etc.
const axiosClient = axios.create({
    baseURL: `${API_BASE_URL}/api`,
});

// Attach the admin's JWT to every request that has one stored.
axiosClient.interceptors.request.use((config) => {
    const token = getToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

// A rejected or expired token means the stored session is useless — drop it and
// send the admin back to the login screen.
axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;

        if (status === 401 || status === 403) {
            clearSession();

            if (window.location.pathname.startsWith("/admin")) {
                window.location.replace("/login");
            }
        }

        return Promise.reject(error);
    }
);

export default axiosClient;
